import './StyleCard.css';
import React from 'react';

function StyleCard({title, image, description}) {
  return (
    <section className="StyleCard">
      <img className="card-img" src={image} alt=""/>
        <div>
        <h3>{title}</h3>
        <hr></hr>
        <p>{description}</p>
        </div>
    </section>
    )
}

export default StyleCard;
